import React from "react";
import { Alert, CircularProgress   } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import Footer from "../components/Footer";
import ButtonWhatsapp from "../components/ButtonWhatsapp";
import NavbarLogo from "../components/NavbarLogo";
import api from "../services/api";
export default function ContactUs() {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  const [loading, setLoading] = React.useState(false); // Nuevo estado para el cargador

  const [formData, setFormData] = React.useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const [responseMessage, setResponseMessage] = React.useState("");
  const [messageType, setMessageType] = React.useState(""); // 'success' o 'error'
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;
    setResponseMessage("");
    setLoading(true); // Activar el cargador antes de enviar

    try {
      await api.post("/api/contact", formData, { timeout: 60000 });
      setResponseMessage("Mensaje enviado correctamente");
      setMessageType("success");
      setFormData({ name: "", email: "", subject: "", message: "" });
    } catch (error) {
      const status = error.response?.status;
      setResponseMessage(
        status === 503
          ? "El servicio de correo no está disponible. Revisá la configuración de EMAIL y PASS en el servidor."
          : status === 400
            ? "Completá todos los campos con datos válidos."
            : error.code === "ECONNABORTED"
              ? "El servidor tardó demasiado en responder. El envío no pudo confirmarse."
              : !error.response
                ? "No se pudo conectar con el servidor. Intentá nuevamente en unos minutos."
                : "El servidor no pudo enviar el correo. Intentá nuevamente en unos minutos."
      );
      setMessageType("error");
    } finally {
      setLoading(false); // Desactivar el cargador después de completar la solicitud
    }
  };

  const [showSpinner, setShowSpinner] = React.useState(true);

  React.useEffect(() => {
    const timeout = setTimeout(() => {
      setShowSpinner(false);
    }, 1);

    return () => clearTimeout(timeout); // Limpieza del timeout
  }, []);
  return (
    <div>
      {showSpinner && (
        <div
          id="spinner"
          class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center"
        >
          {/* Aquí puedes personalizar el spinner */}
          <div class="spinner"></div>
        </div>
      )}

      <div className="container-fluid bg-primary px-5 d-none d-lg-block">
        <div className="row gx-0">
          <div className="col-lg-8 text-center text-lg-start mb-2 mb-lg-0">
            <div
              className="d-inline-flex align-items-center"
              style={{ height: "45px" }}
            >
              <a
              href="https://wa.me/+541161361408?text=¡Hola!%20Quisiera%20más%20información%20sobre%20tus%20servicios%20de%20desarrollo%20web%20y%20aplicaciones."
                className="text-light"
                target="_blank"
                rel="noopener noreferrer"
              >
                <small className="me-3 text-light">
                  <i
                    className="bi bi-whatsapp me-2"
                    style={{ color: "white" }}
                  ></i>
                  +54 11 6136 1408
                </small>
              </a>
              <a
                href="tel:+541161361408"
                className="text-light"
                target="_blank"
                rel="noopener noreferrer"
              >
                <small className="me-3 text-light">
                  <i className="fa fa-phone-alt me-2"></i>+54 11 6136 1408
                </small>
              </a>
              <a
                href="mailto:info@elaritech.com"
                className="text-light"
                target="_blank"
                rel="noopener noreferrer"
              >
                <small className="text-light">
                  <i className="fa fa-envelope-open me-2"></i>info@elaritech.com
                </small>
              </a>
            </div>
          </div>
          <div className="col-lg-4 text-center text-lg-end">
            <div
              className="d-inline-flex align-items-center"
              style={{ height: "45px" }}
            >
              {/*    <a className="btn btn-sm btn-outline-light btn-sm-square rounded-circle me-2" href=""><i className="fab fa-twitter fw-normal"></i></a> */}
              <a
                className="btn btn-sm btn-outline-light btn-sm-square rounded-circle me-2"
                href="https://www.facebook.com/profile.php?id=61572272330417"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-facebook-f fw-normal"></i>
              </a>
              {/*                     <a className="btn btn-sm btn-outline-light btn-sm-square rounded-circle me-2" href=""><i className="fab fa-linkedin-in fw-normal"></i></a>
                    <a className="btn btn-sm btn-outline-light btn-sm-square rounded-circle me-2" href=""><i className="fab fa-instagram fw-normal"></i></a>
                    <a className="btn btn-sm btn-outline-light btn-sm-square rounded-circle" href=""><i className="fab fa-youtube fw-normal"></i></a> */}
            </div>
          </div>
        </div>
      </div>

      <div class="container-fluid position-relative p-0">
        <nav className="navbar navbar-expand-lg navbar-dark px-5 py-3 py-lg-0">
          <NavbarLogo />
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarCollapse"
          >
            <span className="fa fa-bars"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarCollapse">
            <div className="navbar-nav ms-auto py-0">
              <Link to="/" className="nav-item nav-link ">
                Inicio
              </Link>
              <Link to="/sobre-nosotros" className="nav-item nav-link">
                Sobre Nosotros
              </Link>
              <Link to="/nuestros-servicios" className="nav-item nav-link">
                Servicios
              </Link>

              <Link to="/contáctanos" className="nav-item nav-link active">
                Contáctanos
              </Link>
            </div>
            <Link to="/cotización" class="btn btn-primary py-2 px-4 ms-3">
              Solicitar Cotización
            </Link>
          </div>
        </nav>

        <div
          class="container-fluid bg-primary py-5 bg-contact"
          style={{ marginBottom: "90px" }}
        >
          <div class="row py-5">
            <div class="col-12 pt-lg-5 mt-lg-5 text-center">
              <h1 class="display-4 text-white animated zoomIn">Contáctanos</h1>
            </div>
          </div>
        </div>
      </div>

      <div class="modal fade" id="searchModal" tabindex="-1">
        <div class="modal-dialog modal-fullscreen">
          <div
            class="modal-content"
            style={{ background: "rgba(0, 0, 0, 0.5)" }}
          >
            <div class="modal-header border-0">
              <button
                type="button"
                class="btn bg-white btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body d-flex align-items-center justify-content-center">
              <div class="input-group" style={{ maxWidth: "100%" }}>
                <input
                  type="text"
                  class="form-control bg-transparent border-primary p-3"
                  placeholder="Type search keyword"
                />
                <button class="btn btn-primary px-4">
                  <i class="bi bi-search"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="container-fluid  wow fadeInUp" data-wow-delay="0.1s">
        <div class="container">
          <div
            class="section-title text-center position-relative pb-3 mb-5 mx-auto"
            style={{ maxWidth: "600px" }}
          >
            <h5 class="fw-bold text-primary text-uppercase">Contáctanos</h5>
            <h2 className="h1 mb-0">
              Si tiene alguna pregunta, no dude en contactarnos.
            </h2>
          </div>
          <div class="row g-5 mb-5">
            <div class="col-lg-4">
              <div
                class="d-flex align-items-center wow fadeIn"
                data-wow-delay="0.1s"
              >
                <div
                  class="bg-primary d-flex align-items-center justify-content-center rounded"
                  style={{ width: "60px", height: "60px" }}
                >
                  <i class="fa fa-phone-alt text-white"></i>
                </div>
                <div class="ps-4">
                  <h5 class="mb-2">Llámanos</h5>
                  <h4 class="text-primary mb-0">
                    <a href="tel:+541161361408" class="mb-0">
                      +54 11 6136 1408
                    </a>
                  </h4>
                </div>
              </div>
            </div>
            <div class="col-lg-4">
              <div
                class="d-flex align-items-center wow fadeIn"
                data-wow-delay="0.4s"
              >
                <div
                  class="bg-primary d-flex align-items-center justify-content-center rounded"
                  style={{ width: "60px", height: " 60px" }}
                >
                  <i class="fa fa-envelope-open text-white"></i>
                </div>
                <div class="ps-4">
                  <h5 class="mb-2">Correo electrónico</h5>
                  <h4 class="text-primary mb-0">
                    <a
                      href="mailto:info@elaritech.com"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      info@elaritech.com
                    </a>
                  </h4>
                </div>
              </div>
            </div>
            <div class="col-lg-4">
              <div
                class="d-flex align-items-center wow fadeIn"
                data-wow-delay="0.8s"
              >
                <div
                  class="bg-primary d-flex align-items-center justify-content-center rounded"
                  style={{ width: "60px", height: "60px" }}
                >
                  <i class="fab fa-whatsapp text-white"></i>
                </div>
                <div class="ps-4">
                  <h5 class="mb-2">Contáctanos por WhatsApp</h5>
                  <h4 class="text-primary mb-0">
                    <a
                      href="https://wa.me/+541161361408"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Click aquí
                    </a>
                  </h4>
                </div>
              </div>
            </div>
          </div>
          <div class="row g-5">
            <div class="col-lg-6 wow slideInUp" data-wow-delay="0.3s">
              <form onSubmit={handleSubmit}>
                <div className="row g-3">
                  <div className="col-md-6">
                    <input
                      type="text"
                      className="form-control border-0 bg-light px-4"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder="Nombre completo"
                      style={{ height: "55px" }}
                      required
                    />
                  </div>
                  <div className="col-md-6">
                    <input
                      type="email"
                      className="form-control border-0 bg-light px-4"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="Correo electrónico"
                      style={{ height: "55px" }}
                      required
                    />
                  </div>
                  <div className="col-12">
                    <input
                      type="text"
                      className="form-control border-0 bg-light px-4"
                      name="subject"
                      value={formData.subject}
                      onChange={handleChange}
                      placeholder="Asunto"
                      style={{ height: "55px" }}
                      required
                    />
                  </div>
                  <div className="col-12">
                    <textarea
                      className="form-control border-0 bg-light px-4 py-3"
                      rows="4"
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="col-12">
                    <button
                      className="btn btn-primary w-100 py-3"
                      type="submit"
                      disabled={loading}
                    >

                          {loading ? (
                                              <CircularProgress size={24} color="inherit" /> // Mostrar el cargador
                                            ) : (
                                              'Enviar Mensaje'
                                            )}
                    </button>
                  </div>
                </div>
              </form>
              {responseMessage && (
                <Alert
                  severity={messageType === "success" ? "success" : "error"}
                  style={{ marginTop: "20px", textAlign: "center" }}
                >
                  {responseMessage}
                </Alert>
              )}
            </div>
            <div class="col-lg-6 wow slideInUp" data-wow-delay="0.6s">
              <img
                src={require("../img/bg-slide.webp")}
                alt="Innovación Tecnológica"
                className="img-fluid rounded shadow"
              />
            </div>
          </div>
        </div>
      </div>

      <Footer />
      <ButtonWhatsapp />
    </div>
  );
}
